import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useWorkflowDoc from '@actions/services/firestore/browser/workflow/use';
import { BreadcrumbLink } from '@/components/ui/breadcrumb';
import { WorkflowsFolderCrumbProps } from './types';

const WorkflowsFolderCrumb = ({ param }: WorkflowsFolderCrumbProps) => {
    const params = useParams();
    const workflowId = params[param];
    const agentId = params.agentId;

    // Only fetch workflow if workflowId is available
    const { data: workflow } = useWorkflowDoc(workflowId || '', {
        disabled: !workflowId,
    });

    // Construct href with folder query param if workflow has folderPath
    let href = agentId ? `/agents/${agentId}/workflows` : '/workflows';

    // Only add folder query param if we have a workflow with a folderPath
    if (workflowId && workflow?.folderPath) {
        href += `?folder=${encodeURIComponent(workflow.folderPath)}`;
    }

    return (
        <BreadcrumbLink asChild>
            <Link to={href}>
                <div className="flex items-center gap-2">Workflows</div>
            </Link>
        </BreadcrumbLink>
    );
};

export default WorkflowsFolderCrumb;
